import { Component, ResourceManager, RuntimeEngine } from '@easytwin/runtime';
import { useCallback, useEffect, useState } from 'react';

export const useGetNewModelMaterial = (engine: RuntimeEngine, url: string | undefined) => {
  const [data, setData] = useState<
    {
      name: string;
      id: string;
    }[]
  >([]);
  const [loaded, setLoaded] = useState(false);

  const queryFn = useCallback(async () => {
    setLoaded(false);
    if (url) {
      const resourceMgr = engine?.getManager(ResourceManager);
      const data = await resourceMgr?.getModelInitData(url);
      if (data?.materialMap.entries())
        setData(
          Array.from(data?.materialMap.entries()).map(([key, value]) => {
            return { name: key.name, id: value };
          }),
        );
    }
    setLoaded(true);
  }, [url]);

  useEffect(() => {
    queryFn();
  }, [queryFn]);

  return { data, loaded };
};

export const getOriginModelMaterial = (comp: Component) => {
  if (comp.type !== 'Model' && comp.type !== 'InstanceModel') return [];
  const originalMats: { name: string; id: string }[] = [];
  (comp as any).materialSlots.forEach((item: any, key: string) =>
    originalMats.push({ name: item.originalMaterial.name, id: key }),
  );
  return originalMats;
};
